import { Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Grid = ({ className, sizes, children, ...props }) => (
  <div className={classNames('grid', className)} {...props}>
    <div className="grid__items">
      {Children.map(children, (child) => {
        if (!isValidElement(child)) {
          return child;
        }

        return cloneElement(child, {
          sizes: child.props.sizes || sizes,
        });
      })}
    </div>
  </div>
);

Grid.Item = ({ className, sizes, children, ...props }) => (
  <div
    className={classNames(
      'grid__item',
      sizes && Object.entries(sizes)
        .map(([key, [size, columns]]) => `grid__item--${key}-${size}-of-${columns}`),
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

Grid.Item.displayName = 'Grid.Item';

Grid.propTypes = {
  className: PropTypes.string,
  sizes: PropTypes.shape({
    xs: PropTypes.arrayOf(PropTypes.number),
    sm: PropTypes.arrayOf(PropTypes.number),
    md: PropTypes.arrayOf(PropTypes.number),
    lg: PropTypes.arrayOf(PropTypes.number),
    xl: PropTypes.arrayOf(PropTypes.number),
  }),
  children: PropTypes.node,
};

Grid.Item.propTypes = {
  className: PropTypes.string,
  sizes: PropTypes.shape({
    xs: PropTypes.arrayOf(PropTypes.number),
    sm: PropTypes.arrayOf(PropTypes.number),
    md: PropTypes.arrayOf(PropTypes.number),
    lg: PropTypes.arrayOf(PropTypes.number),
    xl: PropTypes.arrayOf(PropTypes.number),
  }),
  children: PropTypes.node,
};

export default Grid;
